export interface Processor {
  jobsCount?: number;
  jobsData?: string[];
  acceptedPolicies?: boolean;
  skills?: {
    [skill: string]: boolean
  };
  id: string;
  firstName: string;
  lastName: string;
  loginEmail: string;
  invoicingPermissions: boolean;
  costViewingPermissions: boolean;
  disabled?: boolean;
}
